import { useHideNav } from '@/shared/hooks/useHideNav'
import { useStyles } from './styles'
import { useBackButton } from '@/shared/hooks/useBackButton'
import { goToTest } from '@/app/routing/events'
import { mappedRoutes } from '@/app/routing/router'
import { GamedBtn } from '@/shared/ui/gamedBtn'

export const DevToolsView = () => {
  useHideNav()
  useBackButton({ onBack: goToTest })
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      <h1>Dev Tools</h1>
      {sortedRoutes.map((route) => (
        <GamedBtn
          style={{
            minHeight: '42px',
          }}
          variant="primary"
          key={route.path}
          onClick={() => {
            window.location.href = route.path
          }}
        >
          {route.path}
        </GamedBtn>
      ))}
    </div>
  )
}

const sortedRoutes = Object.values(mappedRoutes).sort((a, b) => a.path.localeCompare(b.path))
